export default __webpack_public_path__ + "static/media/yesIcon.bb248ed3.svg";